module.exports = __webpack_public_path__ + "static/media/ing3.9cc8489b.jpg";